import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GlobalService } from 'app/shared/services/global.service';
import { SoftwareUpdateService } from 'app/shared/services/update.service';

@Component({
    selector: 'software-update-notification',
    template: `@if (updateService.showSoftwareUpdates() && updateService.newVersionAvailable()) {
        <div class="update-notification-container"><div class="update-notification">
            <span>A new version of this web app is available.</span>
            <button mat-flat-button [color]="'primary'" matTooltip="Update now" (click)="updateNow()">
                <mat-icon class="iapply-mat-icon" [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
                Update now
            </button>
        </div></div>
    }`,
    styleUrl: 'software-update.scss',
    // animations: fuseAnimations,
    imports: [
        MatButtonModule,
        MatIconModule,
    ],
})
export class SoftwareUpdateComponent implements OnInit, OnDestroy
{
    protected global = inject(GlobalService);
    protected updateService = inject(SoftwareUpdateService);

    // updateAvailable = this.global.newVersionAvailable;

    ngOnInit(): void {
        this.updateService.init();
    }

    ngOnDestroy(): void {
        this.updateService.stop();
    }

    updateNow() {
        window.location.reload();
    }
}
